import { useEffect } from "react"
import seqStore from "../../store/seqStore"

export default function Mute({ track  }) {
    const mute = seqStore((state) => state.settings.mute)
    const setMute = seqStore((state) => state.setMute)
    const solo = seqStore((state) => state.settings.solo)

    const handleMute = () => {
        // Check if any other track is soloed
        const isAnyOtherTrackSoloed = Object.entries(solo).some(([i, isSoloed]) => parseInt(i) !== track && isSoloed)
        
        // If any other track is soloed, prevent muting or unmuting the current track
        if (isAnyOtherTrackSoloed) {
            return
        }

        // Check if the current track is soloed
        const isTrackSoloed = solo[track]

        // If the current track is soloed, prevent muting or unmuting
        if (isTrackSoloed) {
            return
        }

        // Toggle mute for the current track
        setMute(track, !mute[track])
    }

    return (
        <div className={mute[track]? `muteOn_${track}` : 'muteOff'} id={`mute_${track}`} onClick={handleMute}><span>M</span></div>
    )
}
